import React, { act, useEffect, useRef } from 'react'
import { useState } from 'react';
import memberLogo from '../../assets/images/Member.png';
import { Link } from 'react-router-dom';
import backLogo from '../../assets/images/Back.png';
import expandLogo from '../../assets/images/Expand Arrow1.png';
import { getActiveGameTypeService } from '../../services/gametype.service';
import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../../reducers/common.reducer";
import { createAgentService, updateAgentService } from '../../services/agent.service';
import { useNavigate } from 'react-router-dom';
import useUserData from '../../hooks/useUserData';
import NewGameType from './components/NewGameType';



const AddNewAgent = () => {

    const [expand, setExpand] = useState(false);

    const [userData, setUserData] = useUserData();
    const [gameTypeData, setGameTypeData] = useState();
    const [gameTypeEquation, setGameTypeEquation] = useState([]);
    const [errors, setErrors] = useState({});
    const [follow, setFollow] = useState({ userId: '', name: 'User Name' });
    const [inputData, setInputData] = useState({ agentName: '', userId: '', remain: 0 });

    const dispatch = useDispatch();
    const navigate = useNavigate();
   // let gameType = useGameTypeData();

   const handleWheel = (event) => event.target.blur();

    const handleChange = (e) => {
        errors.agentName = '';
        // const { name, value } = e.target;

        // const numericValue = name === 'remain' ? Number(value) : value;// Destructure name and value from event target
        // setInputData({
        //     ...inputData,  // Spread the existing state
        //     [name]: numericValue // Dynamically update the field based on the name attribute
        // });
        setInputData({
            ...inputData,
            [e.target.name]: e.target.value
        });
    }

    useEffect(() => {
        setInputData({
            ...inputData,
            userId: follow.userId
        })
    },[follow])

    const handleSave = () => {
        const validateErrors = validate();
        if(Object.keys(validateErrors).length === 0) {
            createAction();
        }
        else {
            setErrors(validateErrors);
        }
    }

    const validate = () => {
        let errors = {};
        if(!inputData.agentName) {
            errors.agentName = 'Agent Name is required';
        }

        return errors;
    }


    const getActiveGameType = async() => {

        try {
            dispatch(setIsLoading(true));
            const result = await getActiveGameTypeService();

            if (result?.data) {
                setGameTypeData(result.data);
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error?.includes('streaming buffer')
                    ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                    : error?.response?.data?.message || error?.message;

            dispatch(
                setToastMessage({
                    message: errorMessage,
                    type: "error",
                })
            );
        } finally {
            dispatch(setIsLoading(false));
        }

    }

    const createAction = async () => {

        dispatch(setIsLoading(true))
        try {
            let result;
            result = await createAgentService({
                AgentData: inputData, gameTypeEquation: gameTypeEquation
            })

            if(result.data) {
                navigate('/agent');
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error?.includes('streaming buffer')
                    ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                    : error?.response?.data?.message || error?.message;

            dispatch(
                setToastMessage({
                    message: errorMessage,
                    type: "error",
                })
            );
        } finally {
        dispatch(setIsLoading(false))
        }
    }

    const selectUser= ( e ) => {
            e.stopPropagation();
            setExpand(!expand);
    }

    useEffect(()=> {
        getActiveGameType()
    }, [])

    return (
        <div className='px-4 bg-bgColor h-[83vh] text-sm' onClick={()=>setExpand(false)}>
            <div className='flex'>
                <img src={memberLogo} alt='user-Logo' className=' w-6' />
                <span className='ms-2 text-fgColor font-bold'>/ Agent / Add New</span>
            </div>
            <div className='mt-4 bg-rectangle w-full h-auto rounded-md pt-4 mb-8 px-4'>
                <button className='text-rectangle bg-primary w-[200px] h-[40px] me-2 rounded-md'>
                    <Link to="/agent" className='flex items-center font-semibold'>
                        <img src={backLogo} alt="" className='w-6 h-4 pe-2 ms-2' />
                        <div className='flex justify-center ms-12'>Back</div>
                    </Link>
                </button>

                <div className='w-full flex justify-center'>
                    <div className='w-[90%] mt-6 '>
                        <div className='flex pb-6 border-b-2 w-full'>
                            <input
                                type='text'
                                placeholder='Agent Name'
                                name='agentName'
                                value={inputData.agentName}
                                onChange={handleChange}
                                className='me-6 bg-bgColor text-fgColor py-2 ps-4 w-[200px] outline-none font-semibold rounded-md' />

                                {errors.agentName && alert(errors.agentName)}

                            <div className='flex items-center justify-between bg-bgColor text-fgColor py-2 ps-4 w-[200px] cursor-pointer font-semibold rounded-md relative'
                                onClick={(e)=>selectUser(e)}>
                                <div>{follow.name}</div>
                                <img src={expandLogo} alt="Expand-logo" className='' />
                                {
                                    expand ?
                                        <div className="bg-bgColor text-fgColor w-[200px] absolute top-[45px] left-0 cursor-pointer overflow-auto h-[200px] z-40">
                                            {
                                                userData && userData.map((user) => (
                                                    <div key={user.userId}
                                                        className={`${user.userId != user.length ? "border-b-2 " : "border-b-0"} py-2 px-4 hover:bg-primary hover:text-rectangle transition-all duration-100 `}

                                                        onClick={() => setFollow({ userId: user.userId, name: user.name })}
                                                    >
                                                        {user.name}
                                                    </div>
                                                ))
                                            }
                                        </div> : ""
                                }
                            </div>
                            <input
                                type='number'
                                placeholder='Initial Remains'
                                name='remain'
                                onWheel={handleWheel}
                                className='ms-6 bg-bgColor text-fgColor text-end py-2 px-2 w-[150px] outline-none font-semibold rounded-md'
                                value={inputData.remain}
                                onChange={(e) => handleChange(e)} />
                        </div>

                        <NewGameType
                            setGameTypeEquation={setGameTypeEquation}
                            gameTypeEquation={gameTypeEquation}
                            gameTypeData={gameTypeData}
                        />
                    </div>
                </div>
                <button className='text-rectangle bg-primary w-[200px] h-[40px] me-2 rounded-md font-semibold mt-4 mb-6' onClick={handleSave}>
                    Save
                </button>
            </div>

        </div>
    )
}

export default AddNewAgent
